import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Avatar, Chip } from '@mui/material';
import UserModal from './UserModal';
import { formatID, formatName } from '../utils/formatAttributes';
import { useAuth } from '../utils/AuthContext';
import { DataGrid } from '@mui/x-data-grid';

const roleColors = (role) => {
  switch (role) {
    case 'STUDENT':
      return 'primary';
    case 'ADMIN':
      return 'secondary';
    case 'JUDGE':
      return 'warning';
    case 'FACULTY':
      return 'success';
    default:
      return 'default';
  }
};
export default function UsersTable({
  rows,
  flag,
  setFlag,
  adminMode = false,
  externalAction,
}) {
  const { user } = useAuth();

  const columns = [
    {
      field: 'icon',
      headerName: 'Users',
      width: 100,
      renderCell: (params) => (
        <Avatar
          alt={params.row.fullName}
          src={
            params.row.icon
              ? `${process.env.REACT_APP_SPACES_ENDPOINT_PROFILE_ICONS}${params.row.icon}`
              : params.row.avatar
          }
          sx={{ width: 50, height: 50 }}
        />
      ),
    },
    {
      field: 'fullName',
      headerName: 'Full Name',
      flex: 1,
      renderCell: (params) => (
        <>
          {formatName(params?.row?.prefix || '', params?.row?.fullName || '')}
        </>
      ),
    },
    { field: 'email', headerName: 'Email', flex: 1 },
    {
      field: 'department',
      headerName: 'Department',
      width: 100,
      type: 'singleSelect',
      valueOptions: ['CIS', 'ECE', 'ME', 'IMSE', 'N/A'],
    },
    ...(user?.department !== 'ME'
      ? [
          {
            field: 'course',
            headerName: 'Course',
            width: 100,
            type: 'singleSelect',
            valueOptions: ['SD1', 'SD2', 'BOTH', 'N/A', ''],
          },
        ]
      : []),
    {
      field: 'role',
      headerName: 'Role',
      flex: 1,
      type: 'singleSelect',
      valueOptions: ['STUDENT', 'JUDGE', 'FACULTY', 'ADMIN'],
      renderCell: (params) => (
        <Chip
          label={params.row.role}
          color={roleColors(params.row.role)}
          sx={{ color: 'white', fontWeight: 'bold' }}
        />
      ),
    },
    ...(adminMode
      ? [
          {
            field: 'actions',
            headerName: 'Actions',
            flex: 1,
            renderCell: (params) => (
              <UserModal user={params.row} flag={flag} setFlag={setFlag} />
            ),
          },
        ]
      : []),
    ...(externalAction
      ? [
          {
            field: 'external',
            headerName: 'Actions',
            flex: 1,
            renderCell: (params) => externalAction(params.row),
          },
        ]
      : []),
  ];
  const paginationModel = { page: 0, pageSize: 25 };
  return (
    <div style={{ height: 500, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[25, 50, 100]}
        sx={{
          height: 500, // Ensure it has a height
          border: '1px solid #ddd',
          borderRadius: 2,
          overflow: 'hidden',
          '& .MuiDataGrid-columnHeaders': {
            fontSize: '1rem',
            fontWeight: 'bold',
          },
          '& .MuiDataGrid-root': {
            backgroundColor: 'white',
          },
          '& .MuiDataGrid-cell': {
            fontSize: '0.9rem',
            borderBottom: '1px solid #eee',
          },
          '& .MuiDataGrid-row:nth-of-type(even)': {
            backgroundColor: '#f4f4f4',
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#e3f2fd',
          },
        }}
      />
    </div>
  );
}
